const unknownError = "An unknown error occurred, please try again later";
const unauthorizedError = "Unauthorized resource.";
const fieldSavingError = "Error saving field";

export { unknownError, unauthorizedError, fieldSavingError };
